/**
 * External Dependencies
 */
import 'jquery';
import 'jquery-inline-svg';

import './lib/menu';
import './lib/page-header';
import './lib/animations';

$(window).load(() => {
    $('.mailpoet_paragraph.open-form .wp-block-button__link').on("click", function (e) {
        e.preventDefault();

        $('.mailpoet_paragraph').css({
            display: "flex"
        })

        $('.last').css({
            display: "block"
        })
    });

  // Turn img to inline svg
  $('[data-inline-svg]').inlineSvg();

  let vh = window.innerHeight * 0.01;
  // Then we set the value in the --vh custom property to the root of the document
  document.documentElement.style.setProperty('--vh', `${vh}px`);
});






// let scrollpos = window.scrollY
// const header = document.querySelector('.content > .wp-block-media-text, .aaa-blog .preview, .aaa-events .preview')
// const header_height = header.offsetHeight

// const add_class_on_scroll = () => header.classList.add("fade-in")
// const remove_class_on_scroll = () => header.classList.remove("fade-in")

// window.addEventListener('scroll', function() {
//   scrollpos = window.scrollY;

//   if (scrollpos >= header_height) { add_class_on_scroll() }
//   else { remove_class_on_scroll() }

//   console.log(scrollpos)
// })
